import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../../utils/axios";

const fetchSaveBlog = createAsyncThunk(
  "blog/saveBlog",
  async ({ id, isSaved }) => {
    try {
      const response = await axiosInstance.patch(`/blogs/${id}`, { isSaved: !isSaved });
      return response.data;
    } catch (error) {
      console.log("ERROR: ", error);
    }
  }
);

export default fetchSaveBlog;
